export const SET_CATALOG_STATUS = 'RELIC_VAULT/SET_CATALOG_STATUS';
export const SET_CATALOG = 'RELIC_VAULT/SET_CATALOG';
export const SET_VAULT_STATUS = 'RELIC_VAULT/SET_VAULT_STATUS';
export const SET_RELIC_VAULT_STATE = 'RELIC_VAULT/SET_STATE';
export const SET_OWNED_RELICS = 'RELIC_VAULT/SET_OWNED_RELICS';
export const SET_GUARDIAN_STATE = 'RELIC_VAULT/SET_GUARDIAN_STATE';
export const SET_STORE_SLOTS = 'RELIC_VAULT/SET_STORE_SLOTS';
export const RESET_RELIC_VAULT = 'RELIC_VAULT/RESET';
